import {
    Button,
    Pagination,
    Popconfirm,
    Spin,
    Table,
    Tag,
    Input,
    message,
    Switch,
    Select,
    Flex,
    Tooltip,
    Popover,
    Card,
    Drawer,
    Upload,
    Form,
} from "antd";
import React, { useEffect, useState } from "react";
import { ExtractDate, ExtractTime, dispatchtoast, messageConfiguration } from "../../../utils";

// import { MenuList_list, vendorDisable } from "../../../ApiServices/Apifun";
import {
    DeleteOutlined,
    EditFilled,
    LoadingOutlined,
    PlusCircleOutlined,
    PlusOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ComponentTitle from "../../../Common/ComponentTitle";
import { render } from "@testing-library/react";
import errorImage from "../../../assets/images/food.png"
import { BsEye } from "react-icons/bs";
import { MenuListendpoint } from "./MenuListEndpoint";
import { getMenuList_list, setActiveInactive, setDeleteMenu, setUpdateFoodMenu, vendorDisable } from "../../../ApiServices/Apifun";
import { updateActivationStatus } from "../VendorsDetails/VendorapiFunctions";
import AddMenu from "./AddMenu";

const MenuList = () => {





    const [FoodData, setFoodData] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [openBrandModal, setOpenBrandModal] = useState(false);
    const [formbrand] = Form.useForm();
    const [logoFile, setLogoFile] = useState(null);
    const [addloader, setaddloader] = useState(false);

    const [totalPages, setTotalPages] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [id, setId] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [currentStatus, setCurrentStatus] = useState();

    const handleChangeStatus = (id, status) => {
        setIsLoading(true);
        const newStatus = status == 1 ? 0 : 1; // Toggle status

        setDeleteMenu(id)
            .then((response) => {
                if (response.status) {
                    message.success("Status updated successfully");
                    setCurrentStatus(newStatus); // Update local state
                    FetchMenuList();
                } else {
                    message.error("Failed to update status");
                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Error updating status:", err);
                message.error("An error occurred while updating the status");
                setIsLoading(false);
            });
    };

    // 🔹 Upload config
    const uploadProps = {
        beforeUpload: (file) => {
            const isImage = file.type.startsWith("image/");
            if (!isImage) {
                message.error("Only image files allowed!");
                return Upload.LIST_IGNORE;
            }
            setLogoFile(file);
            return false;
        },
        fileList: logoFile ? [logoFile] : [],
        onRemove: () => setLogoFile(null),
        listType: "picture-card",
    };


    const popoverContent = (id, status) => (
        <div>
            <p>Are you sure you want to delete the menu?</p>
            <Button
                type="primary"
                onClick={() => handleChangeStatus(id, status)}
                disabled={isLoading}
            >
                {isLoading ? <Spin size="small" /> : "Confirm"}
            </Button>
        </div>
    );
    const { Search } = Input;
    const location = useLocation();
    const from = location.state?.from;

    const FetchMenuList = (page) => {
        setIsLoading(true);
        getMenuList_list(`?search=${searchTerm}&page=${page || 0}`)
            .then((response) => {
                if (response.status === "success") {
                    setFoodData(response.data?.results || []);
                    setCurrentPage(response.data?.page || 1);
                    setTotalPages(response.data?.totalPages || 0);

                }
                setIsLoading(false);
            })
            .catch((err) => {
                console.error("Error fetching vendor details:", err);
                setIsLoading(false);
            });
    };
    const handlePageChange = (page) => {
        setCurrentPage(page); // Update state to trigger useEffect
    };


    const handleBrandDrawerClose = () => {
        setOpenBrandModal(false);
    };

    const handleErrorImage = (e) => {

        e.target.src = errorImage

    }

    const handleEditMenu = (val) => {

        const formData = new FormData();

        if (!logoFile) {
            message.error("Please upload a logo");
            return;
        }

        formData.append("foodName", val.foodName);
        formData.append("categoryName", val.categoryName);
        // formData.append("restaurantId", vendorId);

        if (logoFile && logoFile instanceof File) {
            formData.append("logo_image", logoFile);
        }

        setaddloader(true);

        setUpdateFoodMenu(formData, id)
            .then((res) => {
                if (res.status) {
                    dispatchtoast(res.message);
                    setaddloader(false);
                    setOpenBrandModal(false);
                    FetchMenuList();
                } else {
                    setaddloader(false);
                }
            })
            .catch((err) => {
                console.error(err);
                setaddloader(false);
            });
    };



    useEffect(() => {
        FetchMenuList(currentPage);
    }, [currentPage, searchTerm]);


    const columnReports = [
        {
            title: "Food Name",
            dataIndex: "foodName",
            key: "foodName",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs font-poppins">
                            {record.foodName?.toUpperCase() ?? "--"}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Category Name",
            dataIndex: "categoryName",
            key: "categoryName",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs font-poppins">{record.categoryName ?? "--"}</p>
                    </>
                );
            },
        },
        {
            title: "Food Image",
            dataIndex: "image",
            key: "image",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <img src={record.imageUrl} width={70} height={70} onError={handleErrorImage} crossOrigin="anonymous" />                    </>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "is_active",
            key: "is_active",
            className: "custom-header",
            render: (_, record) => (
                <Popover
                    content={popoverContent(record.id, record.is_active)}
                    trigger="click"
                    placement="bottom"
                >
                    <Tag
                        style={{
                            fontWeight: "bold",
                            color: "red",
                            backgroundColor: record.is_active == 1 ? "#e0f5f0" : "#FFE1E1",
                            borderColor: record.is_active == 1 ? "lightgreen" : "pink",
                            borderRadius: "0px",
                            cursor: "pointer",
                        }}
                    >
                        {"Delete"}
                    </Tag>
                </Popover>
            ),
        },

        {
            title: "Action",
            dataIndex: "status",
            key: "status",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <div onClick={() => {
                        setLogoFile({
                            uid: "-1",
                            name: "logo.png",
                            status: "done",
                            url: record.imageUrl,
                        });
                        formbrand.setFieldsValue({
                            foodName: record.foodName,
                            categoryName: record.categoryName,
                        });
                        setId(record?.id);
                        setOpenBrandModal(true);

                    }
                    }>

                        <EditFilled />


                    </div>
                );
            },
        },
    ];


    const columns = [
        // {
        //   title: "Image",
        //   dataIndex: "imageUrl",
        //   key: "imageUrl",
        //   className: "custom-header",
        //   render: (text) => {
        //     return (
        //       <>
        //         <p className="font-medium w-[120px]">
        //           <img src={text} onError={handleErrorImage} crossOrigin="anonymous" />
        //         </p>
        //       </>
        //     );
        //   },
        // },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            className: "custom-header ",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            className: "custom-header whitespace-nowrap",
            render: (text) => {
                return (
                    <>
                        <p className="font-medium w-[120px]">
                            {text ? text : "-"}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Phone no.",
            dataIndex: "mobile_number",
            key: "mobile_number",
            className: "custom-header",
            render: (text) => {
                return (
                    <>
                        <p className="font-medium w-[120px]">
                            {text ? text : "-"}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Name",
            dataIndex: "name",
            key: "name",
            className: "custom-header",
        },
        {
            title: "Created Time",
            dataIndex: "register_date",
            key: "register_date",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <p className="text-xs">
                            {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
                        </p>
                    </>
                );
            },
        },
        {
            title: "Status",
            dataIndex: "is_active",
            key: "is_active",
            className: "custom-header",
            render: (_, record) => (
                console.log("==========?>>>>>>>>>>>", record),
                <Popover
                    content={popoverContent(record.id, record.is_active)}
                    trigger="click"
                    placement="bottom"
                >
                    <Tag
                        style={{
                            fontWeight: "bold",
                            color: record.is_active == 1 ? "green" : "red",
                            backgroundColor: record.is_active == 1 ? "#e0f5f0" : "#FFE1E1",
                            borderColor: record.is_active == 1 ? "lightgreen" : "pink",
                            borderRadius: "0px",
                            cursor: "pointer",
                        }}
                    >
                        {record.is_active == 1 ? "Active" : "Inactive"}
                    </Tag>
                </Popover>
            ),
        },
        {
            title: "View",
            dataIndex: "id",
            key: "",
            className: "custom-header",
            render: (data, record) => {
                return (
                    <>
                        <Link to={`/restrolist/${data}`} >
                            <BsEye />
                        </Link>

                    </>
                );
            },
        },
    ];
    return (
        <div className="p-0 md:p-4">

            {/* Search Section */}
            <div className="flex flex-col sm:flex-row justify-end mb-4 gap-2">
                <Input
                    placeholder="Search food menu by name..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full sm:w-1/4"
                />
            </div>

            {/* Card Wrapper */}
            <Card
                title="Food Menu"
                extra={
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => setOpenModal(true)}
                        className="rounded bg-rgbaprimary8"
                    >
                        Add Food Menu
                    </Button>
                }
                bordered
                style={{
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px",
                }}
                className="overflow-x-auto" // horizontal scroll for small screens
            >
                {/* Table */}
                <Table
                    bordered
                    loading={isLoading}
                    columns={columnReports}
                    dataSource={FoodData}
                    pagination={false}
                    size="small"
                    rowClassName="text-gray-700"
                    className="rounded-lg min-w-full history-table"
                    scroll={{ x: "max-content" }} // ensures table scrolls on mobile
                />
            </Card>

            {/* Pagination */}
            <div className="flex flex-col sm:flex-row justify-between items-center gap-2 mt-4">
                <div className="text-sm text-gray-600">
                    {`Showing ${currentPage * 10 - 9} to ${currentPage * 10 > totalPages * 10 ? totalPages * 10 : currentPage * 10
                        } of ${totalPages * 10} items`}
                </div>
                <Pagination
                    total={totalPages * 10} // Assuming 10 items per page
                    showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                    onChange={handlePageChange}
                    defaultPageSize={10}
                    current={currentPage}
                    size="small"
                />
            </div>

            {/* Add Menu Modal */}
            <AddMenu
                isOpen={openModal}
                setIsOpen={setOpenModal}
                from={from}
                FetchMenuList={FetchMenuList}
            />

            {/* Edit Menu Drawer */}
            <Drawer
                title="Edit Menu"
                width={400}
                onClose={handleBrandDrawerClose}
                visible={openBrandModal}
                bodyStyle={{ paddingBottom: 80 }}
                className="w-full sm:w-[400px]" // responsive drawer width
            >
                <Form layout="vertical" form={formbrand} onFinish={handleEditMenu}>
                    <Form.Item
                        name="foodName"
                        label="Food Name"
                        rules={[{ required: true, message: "Please enter Food Name" }]}
                    >
                        <Input placeholder="Enter Food Name" />
                    </Form.Item>

                    <Form.Item
                        name="categoryName"
                        label="Category Name"
                        rules={[{ required: true, message: "Please enter your Category Name" }]}
                    >
                        <Input placeholder="Enter your Category Name" />
                    </Form.Item>

                    {/* Upload Logo */}
                    <Form.Item label="Brand Logo" required>
                        <Upload {...uploadProps}>
                            {!logoFile && (
                                <div className="flex flex-col items-center justify-center p-2 border rounded cursor-pointer">
                                    <PlusOutlined />
                                    <div className="mt-1 text-xs">Upload</div>
                                </div>
                            )}
                        </Upload>
                    </Form.Item>

                    <Button loading={addloader} type="primary" htmlType="submit" block>
                        Edit Food Menu
                    </Button>
                </Form>
            </Drawer>
        </div>

    );

};
export default MenuList;
